export default {
    en: {
        id: 'diagram4b2-11',
        blocks: [
          {
            index: '1',
            task: 'S = Belief is that entrepreneurs succeed either because they plan and execute carefully, or because they possess a wacky self-belief that leads them to bet long odds',
            title: "S = "
          },
          {
            index: '2',
            task: 'C = But most successful new businesses don’t adhere to a script, nor do they bet on long odds',
            title: "C = "
          },
          {
            index: '3',
            task: 'Q = How do they succeed?',
            title: "Q = "
          },
          {
            index: '4',
            task: 'A = They blend two contradictory skills – careful analytical thinking and a willingness to push boundaries',
            title: "A = No",
            disabled: true
          },
        ],
        answers: [
          {
            index: '2',
            title: 'But X does not do either A or B'
          },
          {
            index: '3',
            title: 'How succeed?'
          },
          {
            index: '1',
            title: 'Believe X succeeds because of A or B'
          },
        ],
        title: 'Please drag the boxes with the correct algebraic structure into the right positions so that they match the SCQ statements provided.',
        correctAnswers: 3
    }
}



// WEBPACK FOOTER //
// ./client/app/modules/courses/4/4b2/spottingSCQ/i18n/exercise11.js